__turbopack_context__.v({
  "button": "sksoNG_button",
  "disabled": "sksoNG_disabled",
  "inNavBar": "sksoNG_inNavBar",
  "olandschokladApp": "sksoNG_olandschokladApp",
  "selected": "sksoNG_selected",
  "serviceTimeData": "sksoNG_serviceTimeData",
});
